import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { translateFn } from '../../../../utils/translator.helper';
import { ConsoleRequest, DataProviderEntity, DataProviderType } from '../../../../utils/request';
import { EC2Events } from './types';

export class SyncWithEC2PopUp extends NetworkBasePopUp<undefined> {
  protected title = ''; // not used
  protected extraDialogConfigs = {};

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const payload = event.detail;

    try {
      await ConsoleRequest.createRequest<void>({
        dataProviderType: DataProviderType.INTEGRATION,
        dataProviderEntity: DataProviderEntity.MODEL,
        endpoint: 'ProtectedEntitiesAWS',
        method: 'syncAwsInstances',
        payload: {
          companyId: payload.companyId,
          accountId: payload.accountId,
        },
      });

      this.showCustomToast(translateFn('Synchronization with EC2 finished successfully.'));
    } catch (e) {
      this.showErrorToastNotification(translateFn('Synchronization with EC2 failed.'));
    }

    this.data.parentElementRef?.dispatchEvent(
      new CustomEvent(EC2Events.FINISHED_SYNC, { bubbles: true, composed: true, detail: { target: payload.target } })
    );
  }

  protected customSetup() {
    if (!this.data.targets || this.data.targets.length === 0) {
      console.error('Missing targets.');
      return;
    }

    if (this.data.targets.length !== 1) {
      console.error('Only one target accepted for this task.');
      return;
    }

    const target = this.data.targets[0];
    const companyId = target.company?.id;
    const accountId = target.specifics.accountId ?? null;

    if (!companyId) {
      console.error('Missing company id.');
      return;
    }

    this.data.parentElementRef?.dispatchEvent(new CustomEvent(EC2Events.INIT_SYNC, { bubbles: true, composed: true }));
    this.handleConfirmButtonClicked(
      new CustomEvent('click', {
        bubbles: false,
        composed: false,
        detail: {
          companyId: companyId,
          accountId: accountId,
          target: target,
        },
      })
    ).then();
  }
}
